@if (!hasInsurance && isPhoneDamaged()) {
  <app-ice-alert class="error-alert" type="error" [iconName]="IconNames.ice_warning">
    <b>Mobilen har skader som må repareres</b>
    <br />
    <p>Denne avtalen har ikke forsikring, så telefonen må repareres hos en godkjent reparatør før innbytte.</p>
  </app-ice-alert>
} @else {
  <p class="section-title">Klargjøring av mobil for retur</p>
  <p>Det er viktig at kundens telefon er klargjort for retur. Kunden må selv:</p>
  <ul>
    <li>Fjerne SIM-kort og eventuelle minnekort</li>
    <li>Slette alt av innhold og data som er lagret på mobilen</li>
    <li>Deaktivere kodelåsen</li>
    <li>Skru av alle stedstjenestene som Find my iPhone, Find my Mobile osv.</li>
    <li>Sette mobilen tilbake til fabrikkinnstillinger</li>
    <li>Pakke den godt ved retur i post og sende med mottatt retureske</li>
  </ul>

  <p class="section-title">Vurdering av mobil</p>
  <p>
    Telefonens tilstand vurderes ved mottak. Hvis vi finner skader, kan kunden bli fakturert for mellomlegget. Kunden blir
    kontaktet ved avvik.
  </p>

  <p class="section-title">Eierskifte av gammel telefon</p>
  <p>
    Eierskapet til din gamle telefon blir overtatt av Modino AS i det du mottar din nye telefon. Fra du mottar din nye
    telefon har du 14 dager til å levere inn den gamle telefonen. Om den gamle telefonen ikke blir returnert innen fristen
    vil eierskapet gå tilbake til deg, og du vil motta en faktura på totalt utestående beløp på MobilBytte-avtalen
  </p>

  <app-ice-checkbox
    forId="has-customer-accepted-terms"
    label="Kunden er informert om, og godtar at Modino AS overtar eierskapet av telefonen."
    ngDefaultControl
    testId="has-customer-accepted-terms-input"
    [errorOnTouchedOnly]="true"
    [formControl]="hasCustomerAcceptedTerms"
  />

  <app-ice-alert iconWidth="2rem" type="neutral" [iconName]="IconNames.ice_shipping_box">
    <p class="alert-title">Retureske til kunde</p>
    <p class="alert-text">
      Retureske blir sendt til kunde.
      <br />
      Kunde klargjør telefonen selv, og sender returboks med posten.
    </p>
  </app-ice-alert>
}
